import { render, staticRenderFns } from "./AbaEditarLotes.vue?vue&type=template&id=2873d54e"
import script from "./AbaEditarLotes.vue?vue&type=script&lang=ts"
export * from "./AbaEditarLotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports